var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgMail = function SvgMail(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 11,
    fill: "none",
    viewBox: "0 0 16 11",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E73C58",
    d: "M1.2 0a1.2 1.2 0 0 0-.519.117l6.757 6.709a.78.78 0 0 0 1.112 0L15.32.116A1.2 1.2 0 0 0 14.8 0zm14.681.67-5.075 5.039 5.075 4.628c.077-.155.119-.331.119-.516V1.18c0-.183-.044-.356-.119-.51M.113.675A1.2 1.2 0 0 0 0 1.179V9.82c0 .185.042.36.119.516l5.069-4.622zm10.125 5.591-1.12 1.111a1.605 1.605 0 0 1-2.25 0L5.757 6.274.694 10.889c.154.07.325.111.506.111h13.6c.181 0 .353-.04.507-.11z"
  })));
};
export default SvgMail;